import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Search, Zap, Users } from 'lucide-react';
const benefits = [{
  icon: Search,
  title: 'Smart Discovery',
  description: 'Our AI-powered engine helps you find the exact tools you need based on your specific requirements and budget.',
  color: 'text-purple-600',
  bg: 'bg-purple-100'
}, {
  icon: Zap,
  title: 'Instant Insights',
  description: 'Get detailed comparisons, pricing breakdowns, and feature analysis instantly without digging through documentation.',
  color: 'text-blue-600',
  bg: 'bg-blue-100'
}, {
  icon: Users,
  title: 'Community Driven',
  description: 'Join thousands of professionals sharing real-world experiences, reviews, and tips on the best software stacks.',
  color: 'text-cyan-600',
  bg: 'bg-cyan-100'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 50
    }
  }
};
export function Benefits() {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-19">
      <div className="container mx-auto px-6" data-id="element-20">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-22">
            Why Choose Keyanalyzer?
          </h2>
          <p className="text-lg text-slate-600" data-id="element-23">
            We simplify the software selection process so you can focus on
            building great things.
          </p>
        </div>

        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-24">
          {benefits.map((benefit, index) => <motion.div key={index} variants={item} className="group p-8 rounded-2xl bg-slate-50 border border-slate-100 hover:border-slate-200 hover:shadow-xl transition-all duration-300" data-id="element-25">
              <div className={`w-14 h-14 ${benefit.bg} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`} data-id="element-26">
                <benefit.icon className={`w-7 h-7 ${benefit.color}`} data-id="element-27" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-28">
                {benefit.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-29">
                {benefit.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}